import { CalendarCheck } from '@phosphor-icons/react';
import { Badge } from '../ui/badge';
import { formatDeliveryDate } from '../../utils/deliveryDate';

/**
 * Статус наличия автомобиля.
 *
 * ## Источников два, и они разные
 *
 * 1. **`car.deliveryDate`** — структурное поле (`YYYY-MM` или «immediate»),
 *    превращается в «Available now» / «Arriving in March» (#1219). Показывается
 *    **всегда**, когда дилер указал дату: это существующее поведение карточки, и
 *    менять его нельзя.
 * 2. **`car.availability`** — свободный текст дилера из инвентаря
 *    («Disponible en concession»). Он приходит давно, но не показывался нигде.
 *    Включается флагом: появление бейджа там, где его не было, — это изменение
 *    вида клиентской карточки, и дилер решает сам.
 *
 * Структурная дата приоритетнее: «Arriving in March» полезнее покупателю, чем
 * «в наличии у дилера», и показывать оба сразу значит противоречить себе.
 *
 * ## Почему компонент, а не две ветки в разметке страницы
 *
 * До #1330 логика жила инлайном в `CarDetailPage`, и второй источник туда просто
 * некуда было добавить, не превратив разметку в лестницу тернарников. Заодно
 * статус теперь можно поставить в каталог и печать — там он тоже уместен.
 *
 * @param {object} props
 * @param {object} props.car — объект автомобиля из инвентаря.
 * @param {boolean} [props.showStatedAvailability] — показывать ли свободный
 *   текст дилера, когда структурной даты нет. По умолчанию нет.
 * @param {(value: string) => string} [props.translate] — перевод значений
 *   инвентаря; данные Autodis лежат по-французски.
 * @param {string} [props.className]
 */
export const AvailabilityStatus = ({
  car,
  showStatedAvailability = false,
  translate = (value) => value,
  className = '',
}) => {
  if (!car) return null;

  const scheduled = formatDeliveryDate(car);
  const stated =
    showStatedAvailability && typeof car.availability === 'string'
      ? car.availability.trim()
      : '';

  const text = scheduled || (stated ? translate(stated) : '');
  if (!text) return null;

  return (
    <Badge variant="delivery" className={className}>
      <CalendarCheck size={12} aria-hidden="true" />
      {text}
    </Badge>
  );
};

export default AvailabilityStatus;
